import React from "react";
import "../../styles/m3d-vantagens.css";
import moedas from '../../asssets/moedas.png';

export default function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-container">

        <div className="hero-text">
          <h1>M3D VANTAGENS</h1>
          <p className="subtitle">Programa de benefícios para clientes M3D</p>
          <h2 className="points">R$ 1,00 = 1 ponto</h2>

          <div className="hero-buttons">
            <button className="btn-primary">Começar a acumular pontos</button>
            <button className="btn-white">Ver prêmios</button>
          </div>
        </div>

        <div className="hero-image">
          <img src={moedas} alt="Moedas M3D" />
        </div>

      </div>
    </section>
  );
}
